/**
 * An AudioWorkletProcessor that converts input data to 16-bit PCM.
 *
 * @remarks
 * This processor assumes a single input and output, and that the input has a
 * single channel (i.e., mono audio).
 *
 * It copies the input data to the output, and then converts the input data to
 * 16-bit PCM. The processor posts the 16-bit PCM data to this.port, where it
 * can be read by the main thread.
 *
 * TODO: support stereo input and convert it to mono 16-bit PCM.
 */
const PcmAudioWorklet = `
const floatTo16BitPCM = (float32Array) => {
  const buffer = new ArrayBuffer(float32Array.length * 2);
  const view = new DataView(buffer);
  let offset = 0;
  for (let i = 0; i < float32Array.length; i++, offset += 2) {
    let s = Math.max(-1, Math.min(1, float32Array[i]));
    view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
  }
  return buffer;
};

export class PcmAudioWorklet extends AudioWorkletProcessor {
  resampler = null;
  
  constructor(options) {
    super(options);
    this.init(options.processorOptions.outputSampleRate);
  }

  init(outputSampleRate) {
    const { create, ConverterType } = globalThis.LibSampleRate;

    const nChannels = 1;

   create(nChannels, sampleRate, outputSampleRate, {
      converterType: ConverterType.SRC_SINC_BEST_QUALITY, // or some other quality
    }).then((resampler) => {
      this.resampler = resampler;
    });
  }

  process(inputs, outputs) {
    // Pass input data to output
    for (let i = 0; i < Math.min(inputs.length, outputs.length); i++) {
      // Copy input data to output
      const input = inputs[i];
      const output = outputs[i];

      for (let channel = 0; channel < input.length; channel++) {
        if (output[channel]) {
          output[channel].set(input[channel]);
        }
      }
    }

    if (inputs.length > 0 && inputs[0].length > 0 && this.resampler) {
      // Resample the input data to 24 kHz
      const resampled = this.resampler.full(inputs[0][0]);

      // Convert input data to 16-bit PCM
      let max = 0;
      for (let i = 0; i < resampled.length; i++) {
        max = Math.max(max, Math.abs(resampled[i]));
      }
      const chunk = floatTo16BitPCM(resampled);
      this.port.postMessage({ chunk }, [chunk]);
    }

    // Return true to keep the processor alive
    return true;
  }
}

registerProcessor('pcm-audio-worklet', PcmAudioWorklet);
`;

const script = new Blob([PcmAudioWorklet], { type: 'application/javascript' });
const src = URL.createObjectURL(script);
export const PcmAudioWorkletSrc = src;
